import { createReducer, on } from '@ngrx/store';
import { UserStaffInfo } from '@src/suite/common/data-models/service/user-staff-info';
import { extractDateLocale, updateDateLocale } from '@src/suite/common/utils/util';

import { HelloResultsActions } from './hello-results.actions';
import { HelloResultsState } from './hello-results.models';

export const initialHelloResultsState: HelloResultsState = {
    ActiveMac: false,
    CentralServer: '',
    ClientFileVersion: '',
    ClientFileVersion7: '',
    ClientVersion: '',
    ClientVersion7: '',
    Expires: new Date(),
    HelpPath: '',
    HomeDatabase: '',
    HomeIP: '',
    HomeProgram: '',
    Monitor: false,
    Printers: null,
    PrivateChannels: null,
    ServerManager: false,
    SessionID: '',
    Supervisor: false,
    UserID: '',
    UserName: '',
    UserStaffInfo: new UserStaffInfo(),
    Navigation: {},
    PSTSuiteNavigation: {},
    CustomCardFields: [],
    PSTNotificationSettings: {
        Email: { Input: '', Recieve: false },
        Mobile: { Recieve: false },
        Phone: { Input: '', Recieve: false },
        Web: { Recieve: false },
    },
    FtpAvatarLocation: '',
    SecurityPrivileges: [],
    PersonalTimeZone: '',
    PersonalLanguage: '',
    TeamExportFormatTemplates: {},
    EnterpriseExportFormatTemplates: {},
    PersonalExportFormatTemplates: {},
    TeamClipboardTemplates: [],
    ClipboardTemplates: [],
    PersonalClipboardTemplates: [],
    Rtl: false,
    DarkMode: false,
    DayOfWeek: 0,
    WalkMe: '',
};

export const helloResultsReducer = createReducer(
    initialHelloResultsState,
    on(HelloResultsActions.setWeekDaySetting, (state, { dayOfWeek }): HelloResultsState => {
        return { ...state, DayOfWeek: dayOfWeek };
    }),
    on(HelloResultsActions.setLanguageSettings, (state, { language }): HelloResultsState => {
        updateDateLocale(language, state.DayOfWeek);
        return {
            ...state,
            PersonalLanguage: language,
            dateLocale: language,
        };
    }),
    on(HelloResultsActions.setDarkMode, (state, { darkMode }): HelloResultsState => {
        return { ...state, DarkMode: darkMode };
    }),
    on(HelloResultsActions.processHelloResults, (state, { helloResults }): HelloResultsState => {
        return {
            ...state,
            ActiveMac: helloResults.ActiveMac,
            CentralServer: helloResults.CentralServer,
            ClientFileVersion: helloResults.ClientFileVersion,
            ClientFileVersion7: helloResults.ClientFileVersion7,
            ClientVersion: helloResults.ClientVersion,
            ClientVersion7: helloResults.ClientVersion7,
            Expires: helloResults.Expires,
            HelpPath: helloResults.HelpPath,
            HomeDatabase: helloResults.HomeDatabase,
            HomeIP: helloResults.HomeIP,
            HomeProgram: helloResults.HomeProgram,
            Monitor: helloResults.Monitor,
            Printers: helloResults.Printers,
            PrivateChannels: helloResults.PrivateChannels,
            ServerManager: helloResults.ServerManager,
            SessionID: helloResults.SessionID,
            Supervisor: helloResults.Supervisor,
            UserID: helloResults.UserID,
            UserName: helloResults.UserName,
            UserStaffInfo: helloResults.UserStaffInfo,
            Navigation: helloResults.Navigation,
            PSTSuiteNavigation: helloResults.PSTSuiteNavigation,
            CustomCardFields: helloResults.CustomCardFields,
            PSTNotificationSettings: helloResults.PSTNotificationSettings,
            FtpAvatarLocation: helloResults.FtpAvatarLocation,
            SecurityPrivileges: helloResults.SecurityPrivileges,
            PersonalTimeZone: helloResults.PersonalTimeZone,
            PersonalLanguage: helloResults.PersonalLanguage,
            TeamExportFormatTemplates: helloResults.TeamExportFormatTemplates,
            EnterpriseExportFormatTemplates: helloResults.EnterpriseExportFormatTemplates,
            PersonalExportFormatTemplates: helloResults.PersonalExportFormatTemplates,
            TeamClipboardTemplates: helloResults.TeamClipboardTemplates,
            ClipboardTemplates: helloResults.ClipboardTemplates,
            PersonalClipboardTemplates: helloResults.PersonalClipboardTemplates,
            Rtl: helloResults.Rtl,
            DarkMode: helloResults.DarkMode,
            DayOfWeek: helloResults.DayOfWeek || 0,
            WalkMe: helloResults.WalkMe,
            dateLocale: extractDateLocale(helloResults.PersonalLanguage),
        };
    }),
    on(HelloResultsActions.setDirectionality, (state, { rtl }): HelloResultsState => {
        return { ...state, Rtl: rtl };
    })
);
